// Mass Schedule Configuration
// Edit these times as needed - they will appear in the footer and other components

export interface MassTime {
  day: string;
  times: string;
}

export const massSchedule: MassTime[] = [
  {
    day: 'Sunday',
    times: '10:30 AM'
  },
  {
    day: 'Weekdays',
    times: '10:00 AM'
  },
  {
    day: 'Holy Days of Obligation',
    times: '10:00 AM'
  }
];

// Contact Information
export const contactInfo = {
  churchName: 'All Saints Church, Thirsk',
  address: '5 Castlegate, YO7 1HL',
  diocese: 'Diocese of Middlesbrough',
  phone: '01845 527011',
  email: 'allsaintsthirsk@rcdmidd.org.uk',
  priestName: 'Father Rejimon Devasia',
  priestTitle: 'Parish Priest'
};